import { Group } from '@ih/app/shared/apis/interfaces';

export class SetGroups {
  public static readonly type = '[Organisation/Group/List] SetGroups';
  constructor(public readonly groups: Group[]) {}
}
